module.exports = __webpack_public_path__ + "static/media/chill-spins-120x120-dark.64f9dbdc.png";